import { SET_LOGIN_USER, SET_REDIRECT, SET_UPDATE_PROFILE } from '@App/constantes/actions'
import { User } from '../store/user/types'
import { IApplication } from '../store/application/types'

interface UserState {
  user?: User
  currentApp?: IApplication
}

const initialState: UserState = {}

const SignInReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_UPDATE_PROFILE:
      const { payload: user } = action

      return {
        ...state,
        user,
      }
    case SET_LOGIN_USER:
      const { payload } = action

      const currentApp = payload?.applications?.find((item: IApplication) => item.label === 'CONNECT_API')

      return {
        ...state,
        currentApp,
        user: payload,
      }
    case SET_REDIRECT: {
      const { payload } = action

      return {
        ...state,
        redirect: payload,
      }
    }
    default:
      return state
  }
}

export default SignInReducer
